import React from 'react';
import { useOnlineStatus } from 'Hooks/useOnlineStatus';
import './OfflineIndicator.css';

/**
 * Banner displayed when the browser is offline.
 * Automatically hides when connectivity is restored.
 * Uses role="alert" for screen reader accessibility.
 */
const OfflineIndicator = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="offline-indicator" role="alert">
      <span className="wifi-off-icon" aria-hidden="true">
        &#x1F4F6;
      </span>
      You are currently offline. Some features may be unavailable.
    </div>
  );
};

export default OfflineIndicator;
